@if (order$ | async; as order) {
  @if (order.isB2BOrder) {
    <button
      sdButton
      class="button-download-bill"
      type="accent"
      size="m"
      [disabled]="loading$ | async"
      (click)="onClickButtonBill(order)"
    >
      Скачать счёт
    </button>
  }
}
